<template>
    <div>
        <Card :padding="0">
            <p slot="title" class="card-title" v-if="isShowTitle">
                <Icon type="map"></Icon>
                {{chartsTitle}}
            </p>
            <div :style="{height: height}">
                <div style="width:100%;height:100%;" :id="chartsId" v-show="!isShow"></div>
                <div class="chart-error" v-show="isShow">
                    <div class="detail">
                        <span class="detail">暂无数据</span>
                    </div>
                </div>
            </div>
        </Card>
    </div>
</template>

<script>
    export default {
        name: "line-charts",
        props:{
            chartsTitle:String,//图表标题
            chartsId:String,//图表id
            lineCompany:String,//单位
            isShowTitle:{
                type:Boolean,
                default:true
            },
            height:{
                type:String,
                default:'360px'
            }
        },
        data () {
            return {
                isShow:false,//默认不展示缺醒图
            }
        },
        methods:{
            /**
             * 大屏日活用户趋势图数据获取
             */
            initDataSource (curResultData,dateArr, numberArr) {
                let _this=this;
                let dataSource = _this.$echarts.init(
                    document.getElementById(_this.chartsId)
                );
                _this.isShow = curResultData.length <= 0;
                const option = {
                    tooltip: {
                        //数据悬浮
                        trigger: "axis",
                        //自定义悬浮框内容
                        formatter: function (params) {
                            var color = '#39C6E9';//图例颜色
                            var htmlStr = '<div>';
                            htmlStr += params[0].name + '<br/>';//x轴的名称
                            //添加圆点
                            htmlStr += '<span style="margin-right:5px;display:inline-block;width:10px;height:10px;border-radius:5px;background-color:' + color + ';"></span>';
                            //添加一个汉字，格式化自定义文本内容
                            htmlStr += '使用：'+params[0].value+_this.lineCompany;
                            htmlStr += '</div>';
                            return htmlStr;
                        }
                    },
                    xAxis: {
                        type: "category",
                        data: dateArr
                    },
                    yAxis: {
                        type: "value",
                        axisLabel: {
                            formatter: "{value}"+_this.lineCompany
                        }
                    },
                    series: [
                        {
                            data: numberArr,
                            type: "line",
                            itemStyle: {
                                normal: {
                                    color: "#39C6E9",
                                }
                            }
                        }
                    ]
                };
                dataSource.setOption(option);
                window.addEventListener("resize", function () {
                    dataSource.resize();
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../style/common";
</style>
